import React, { useState } from "react";
import axios from "axios";
import logo from "../assets/images/logo.png";

function Footer() {
  const [email, setEmail] = useState("");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const response = await axios.post(`${BACKEND_URL}/auth/subscribers/`, { email });
      setMessage(response.data.message);
      setEmail(""); // Clear the input field
    } catch (err) {
      setError(
        err.response?.data?.error ||
        err.response?.data?.email?.[0] ||
        "Failed to subscribe. Please try again."
      );
    }
  };

  return (
    <footer className="professional-footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="brand-logo">
              <div className="logo-icon">
                <img src={logo} className="footer-logo" alt="DCode Logo" />
              </div>
            </div>
            <p className="brand-description">
              DCode is a developer analytics platform that transforms your team's productivity data and code quality metrics into actionable visual insights.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=100057375554353#" className="social-link" aria-label="Facebook">
                <i className="fa fa-facebook" aria-hidden="true"></i>
              </a>
              <a href="https://x.com/DesigniteTools" className="social-link" aria-label="Twitter">
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="https://www.linkedin.com/company/designite/" className="social-link" aria-label="LinkedIn">
                <i className="fa fa-linkedin" aria-hidden="true"></i>
              </a>
              <a href="mailto:contact@designite-tools.com" className="social-link" aria-label="Email">
                <i className="fa fa-envelope" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* Footer Links */}
          <div className="footer-links">
            {/* Product Column */}
            <div className="link-column">
              <h3 className="column-title">Platform</h3>
              <ul className="link-list">
                <li><a href="/" className="footer-link">Home</a></li>
                <li><a href="/faq" className="footer-link">FAQ</a></li>
                <li><a href="/contact" className="footer-link">Contact</a></li>
              </ul>
            </div>

            {/* Resources Column */}
            <div className="link-column">
              <h3 className="column-title">Other Links</h3>
              <ul className="link-list">
                <li><a href="/docs/index.html" target="_blank" className="footer-link">Documentation</a></li>
                <li><a href="/privacy-policy" className="footer-link">Privacy Policy</a></li>
                <li><a href="/eula" className="footer-link">EULA</a></li>
              </ul>
            </div>

            {/* Subscribe to Newsletter Column */}
            <div className="link-column">
              <h3 className="column-title">Subscribe to Newsletter</h3>
              <p className="subscribe-description">Stay updated with our latest news and updates.</p>
              {message && <p className="success-message">{message}</p>}
              {error && <p className="error-message">{error}</p>}
              <form className="newsletter-form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  className="newsletter-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="newsletter-button">Subscribe</button>
              </form>

            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">© 2025 DCode. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;